<template>
  <div class="box risk-list" v-if="params.flag && false" v-drag ref="rlRef">
    <div class="tabs">
      <div class="tab active"><span>风险排名</span></div>
    </div>
    <div class="close">
      <img src="../assets/images/关闭.png" @click="$parent.toggleProductView('RiskList')" />
    </div>
    <div class="content">
      <div class="type-select">
        <span>类型:</span>
        <el-select v-model="typeValue" placeholder="请选择" size="mini" @change="typeChaneg" transfer="true"
          :popper-append-to-body="false">
          <el-option v-for="item in options" :key="item" :label="item" :value="item">
          </el-option>
        </el-select>
      </div>
      <div class="scrollbar-box" ref="riskRef" @mouseover="mouseover" @mouseout="mouseout">
        <div class="risk-item" v-for="item, index in showRiskData" :key="index">
          <span :class="{
            level: true,
            level2: item.risklevel === 2,
            level3: item.risklevel === 3,
            'level- four': item.risklevel === 4
          }">
            {{ item.riskname }}{{ numberToZhongWen(item.risklevel) }}级
          </span>
          <i></i>
          <span>{{ item.objname }}</span>
        </div>
      </div>
      <div class="rainfall">
        <span class="name">{{ titleName }}</span>
        <div class="echart-box">
          <div id="risk-list-chart"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiData } from '@/api'
import echarts from '@/config/echarts/index.js'
import { mapState } from 'vuex'
import { getRiskListOption } from '@/config/echarts/option/risk-list.js'
export default {
  props: ['params'],
  data() {
    return {
      currentIndex: 0,
      sixChart: null,
      options: [],
      typeValue: '',
      showRiskData: [],
      totalRiskData: [],
      titleName: '',
      time: [],
      hourrf: [],
      temp: [],
      timmer: null
    }
  },
  watch: {
    activeCountyId(id) {
      const point = this.objsList.find(item => item.id === this.activeCountyId)
      this.$nextTick(() => {
        this.slideLive(point)
      })
    },
    'params.flag': {
      handler(flag) {
        if (flag) {
          this.$nextTick(() => {
            this.initEchart()
            this.setZindex()
          })
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapState('home', ['objsList', 'activeCountyId'])
  },
  created() {
    this.nowRiskSort()
  },
  mounted() {
    // this.initEchart()
    this.$bus.$on('showRisk', () => {
      if (!this.params.true) {
        this.$parent.toggleProductView('RiskList')
      }
    })

    setTimeout(() => {
      this.$nextTick(() => {
        if (!this.$refs.riskRef) {
          return
        }
        const riskRef = this.$refs.riskRef
        const scrollHeight = riskRef.scrollHeight - riskRef.offsetHeight
        if (scrollHeight > 0) {
          this.startTimmer(riskRef, scrollHeight)
        }
      })
    }, 4000)
  },
  methods: {
    async nowRiskSort() {
      const company = this.$route.params.company
      const { unit } = JSON.parse(localStorage.getItem(company))
      let result = await apiData.nowRiskSort(unit.id)
      if (result.status === 200) {
        result = result.data
        this.options = Object.keys(result)
        this.typeValue = this.options[0]
        this.totalRiskData = result
        this.typeChaneg(this.typeValue)
      }
    },
    initEchart() {
      this.sixChart = echarts.init(document.getElementById('risk-list-chart'))
      const option = getRiskListOption({ x: [], y: [] })
      this.sixChart.setOption(option)
      const point = this.objsList.find(item => item.id === this.activeCountyId)
      this.slideLive(point)
      window.addEventListener('resize', () => {
        this.sixChart.resize()
      })
    },
    async slideLive(point) {
      const result = await apiData.slideLive({ size: 24, lon: point.lon, lat: point.lat })
      result.time = result.time.map(item => {
        item = this.$moment(item).format('HH:mm')
        return item
      })
      this.time = result.time.filter((item, index) => { return index % 2 === 0 })
      this.hourrf = result.hourrf.filter((item, index) => { return index % 2 === 0 })
      this.temp = result.temp.filter((item, index) => { return index % 2 === 0 })
      if (['高温', '降雨'].includes(this.typeValue)) {
        this.reloadEchart()
      } else {
        this.showRiskData = []
      }
    },

    reloadEchart() {
      let options = {}
      if (this.typeValue === '降雨') {
        options = getRiskListOption({ x: this.time, y: this.hourrf })
        options.series[0].type = 'bar'
        options.series[0].name = '雨量'
        options.yAxis.name = '(mm)'
        options.yAxis.max = Math.floor(Math.max(...this.hourrf) + 2)
        options.yAxis.min = Math.floor(Math.min(...this.hourrf) - 2) < 0 ? 0 : Math.floor(Math.min(...this.hourrf) - 2)
        this.titleName = '24小时降雨量'
      } else {
        options = getRiskListOption({ x: this.time, y: this.temp })
        options.series[0].type = 'line'
        options.series[0].name = '温度'
        options.yAxis.name = '(℃)'
        this.titleName = '24小时温度'
        options.yAxis.max = Math.floor(Math.max(...this.temp) + 2)
        options.yAxis.min = Math.floor(Math.min(...this.temp) - 2)
      }
      this.sixChart.setOption(options)
      this.sixChart.resize()
    },
    typeChaneg(type) {
      this.timmer && clearInterval(this.timmer)
      this.showRiskData = this.totalRiskData[type] ? this.totalRiskData[type] : []
      this.reloadEchart()
      setTimeout(() => {
        this.$nextTick(() => {
          const riskRef = this.$refs.riskRef
          const scrollHeight = riskRef.scrollHeight - riskRef.offsetHeight
          if (scrollHeight > 0) {
            this.startTimmer(riskRef, scrollHeight)
          }
        })
      }, 2000)
    },
    startTimmer(riskRef, scrollHeight) {
      if (this.timmer) {
        clearInterval(this.timmer)
      }
      this.timmer = setInterval(() => {
        riskRef.scrollTo({
          top: riskRef.scrollTop + 1
        })
        if (riskRef.scrollTop > (scrollHeight - 2)) {
          clearInterval(this.timmer)
          setTimeout(() => {
            riskRef.scrollTo({
              top: 0
            })
            setTimeout(() => {
              this.startTimmer(riskRef, scrollHeight)
            }, 2000)
          }, 2000)
        }
      }, 15)
    },

    mouseover() {
      if (this.timmer) {
        clearInterval(this.timmer)
      }
    },
    mouseout() {
      const riskRef = this.$refs.riskRef
      const scrollHeight = riskRef.scrollHeight - riskRef.offsetHeight
      if (scrollHeight > 0) {
        this.startTimmer(riskRef, scrollHeight)
      }
    },

    numberToZhongWen(level) {
      if (level === 1) {
        return '一'
      } else if (level === 2) {
        return '二'
      } else if (level === 3) {
        return '三'
      } else {
        return '四'
      }
    },
    setZindex() {
      this.$nextTick(() => {
        const el = this.$refs.rlRef
        let zIndex = JSON.parse(localStorage.getItem('dialogZIndex'))
        zIndex = zIndex * 1 + 1
        el.style.zIndex = zIndex
        localStorage.setItem('dialogZIndex', JSON.stringify(zIndex))
      })
    }
  }

}
</script>
<style lang="less" scoped>
.box {
  position: fixed;
  top: 18.5vh;
  right: 1.31rem;
  background: #ffffff;
  box-shadow: 0rem 0.13rem 1.13rem 0rem rgba(139, 157, 189, 0.35);
  border-radius: 0.75rem;
  min-width: 31.81rem;
  background: #25324D;

  .tabs {
    display: flex;
    position: absolute;
    top: -1.95rem;
    left: 0;
    z-index: 99;

    .tab {
      background: url("../assets/images/矩形-白色.png") no-repeat;
      background-size: 100% 100%;
      font-size: 1.13rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFF;
      text-align: center;
      padding: 1.6rem 2.3rem;

      span {
        cursor: pointer;
      }
    }

    .tab.active {
      background: url("../assets/images/矩形-蓝色.png") no-repeat;
      background-size: 100% 100%;
      color: #fff;
    }

    .tab:not(:first-child) {
      margin-left: -2rem;
    }
  }

  .close {
    position: absolute;
    right: 1.25rem;
    top: 2%;

    img {
      width: 0.75rem;
      cursor: pointer;
    }
  }
}

.risk-list {
  top: 18.5vh;
  height: 58%;
  z-index: 999;

  .content {
    display: flex;
    flex-direction: column;
    padding: 8% 1.31rem 3%;
    width: 100%;
    height: 100%;
    overflow: hidden;
    box-sizing: border-box;

    .scrollbar-box {
      flex: 1;
      overflow: hidden;
      overflow-y: auto;
    }

    .risk-item {
      color: #FFF;
      font-size: 0.88rem;
      padding: 0.88rem 0;
      border-bottom: 1px solid #f5f5f5;
      display: flex;
      align-items: center;

      i {
        display: inline-block;
        width: 0.69rem;
        height: 0.69rem;
        background: #ff5d49;
        border: 0.13rem solid #ffd7d2;
        border-radius: 50%;
        margin: 0 0.69rem;
      }

      .level {
        color: #ff7e6e;
        border: 1px solid #ff5d49;
        background: #fffafa;
        padding: 0.3rem;
        display: inline-block;
      }

      .level2 {
        color: #FF7B00;
        border: 1px solid #FF7B00;
        background: #FFF9F1;

        +i {
          background: #FF7B00;
          border: 0.13rem solid #FFEACF;
        }
      }

      .level3 {
        color: #FFB900;
        border: 1px solid #FFB900;
        background: #FFF9F1;

        +i {
          background: #FFB900;
          border: 0.13rem solid #FFEBB8;
        }
      }

      .level-four {
        color: #2D74F5;
        border: 1px solid #2D74F5;
        background: #F7FAFF;

        +i {
          background: #2D74F5;
          border: 0.13rem solid #E0EBFF;
        }
      }
    }

    .type-select {
      height: 1.85vw;

      span {
        margin-right: 0.78vw;
        font-size: 0.83vw;
        font-weight: 500;
        color: #FFF;
        line-height: 1.15vw;
      }

      .el-select {
        width: 10.89vw;
        height: 1.72vw;
      }
    }
  }
}

.rainfall {
  display: flex;
  height: 12.06vw;
  display: flex;
  flex-direction: column;
  margin-top: 1.04vw;

  .name {
    height: 1.15vw;
    font-size: 0.83vw;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFF;
    line-height: 1.15vw;
    margin-bottom: 0.78vw;
  }

  .echart-box {
    flex: 1;
    display: flex;
  }

  #risk-list-chart {
    flex: 1;
  }
}

::-webkit-scrollbar {
  width: 0.32vw;
}

::-webkit-scrollbar-track {
  background: #E7E7E7;
  border-radius: 1.09vw;
}

::-webkit-scrollbar-thumb {
  background: #D8D8D8;
  border-radius: 1.09vw;
  height: 1.56vw;
}

/deep/ .el-input__inner {
  background: #15324D;
}
</style>
